//Proofed
import SearchIcon from '@mui/icons-material/Search'
import DescriptionIcon from '@mui/icons-material/Description'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import HandshakeIcon from '@mui/icons-material/Handshake'
import PublicIcon from '@mui/icons-material/Public'

export const ACCENT = '#C8102E'   // Vietnam-flag red, used sparingly as accent or #DA251D

export const journey = [
    {
        Icon: SearchIcon,
        step: '01',
        title: 'Market Mapping & Strategic Foundation',
        body: 'We began with a bespoke UK market entry analysis identifying the public sector buyers most relevant to their product range, the frameworks through which those contracts are awarded and a realistic revenue timeline. This gave them clarity on where to focus before a single pound was spent on bid preparation',
    },
    {
        Icon: DescriptionIcon,
        step: '02',
        title: 'Bid Writing & Tender Submission',
        body: 'Our specialist bid writers produced ITT responses, Selection Questionnaire submissions and social value statements tailored to UK public sector evaluators. We wrote in English, in the voice of their business and with deep knowledge of what UK buyers actually look for when scoring responses',
    },
    {
        Icon: TrendingUpIcon,
        step: '03',
        title: 'Ongoing Pipeline Development',
        body: 'Market entry is not a one-time event. We implemented continuous opportunity monitoring, contract expiry tracking to identify buyers nearing renewal and bid/no-bid decision support ensuring their pipeline remained active and well-targeted throughout',
    },
]

export const challenges = [
    {
        heading: 'No visibility of where contracts are',
        body: 'UK public sector procurement is spread across hundreds of buyer portals, frameworks and notice types. Without specialist intelligence tools, opportunities are missed entirely or discovered too late to bid competitively',
    },
    {
        heading: 'Responses written for a different audience',
        body: 'UK evaluators score against specific criteria with a specific language. A strong product and a well-intentioned submission are not the same as a winning one. The gap is almost always in how responses are written, not what the supplier can deliver',
    },
    {
        heading: 'Compliance and qualification requirements',
        body: 'UK public sector buyers require specific accreditations, financial standing evidence and supply chain transparency. Understanding what is needed and preparing it in advance is a prerequisite for being considered at all',
    },
]

export const heroOutcomes = [
    '3 major tender submissions prepared and submitted by the CFP bid team',
    'Active pipeline of tracked opportunities across three buyer categories',
    'Full compliance documentation package prepared and maintained',
    // 'Qualified on a framework within 8 months of engagement',
]

export const qualifierCards = [
    { Icon: HandshakeIcon, label: 'You supply products or services that UK government buyers actually purchase' },
    { Icon: PublicIcon, label: 'You have the capacity to operate and deliver in the UK market' },
    { Icon: TrendingUpIcon, label: 'You are prepared to invest 12-18 months in structured market development' },
    { Icon: SearchIcon, label: 'You want an expert partner, not a generic online course or a directory listing' },
]

// export const pullQuote = {
//     text: '"Before working with Contract Finder Pro, UK public sector procurement felt completely inaccessible. Within eight months we were qualified on a national framework with live tender submissions being managed by their team. We would not have known where to start without them."',
//     attribution: 'Head of International Sales · Vietnamese Textile Manufacturer',
// }
